var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5H13.19C12.739 4.21774 12.1168 3.54767 11.37 3.04L13 1.41L11.59 0L9.42 2.17C8.96 2.06 8.49 2 8 2C7.51 2 7.04 2.06 6.59 2.17L4.41 0L3 1.41L4.62 3.04C3.88 3.55 3.26 4.22 2.81 5H0V7H2.09C2.04 7.33 2 7.66 2 8V9H0V11H2V12C2 12.34 2.04 12.67 2.09 13H0V15H2.81C3.85 16.79 5.78 18 8 18C10.22 18 12.15 16.79 13.19 15H16V13H13.91C13.96 12.67 14 12.34 14 12V11H16V9H14V8C14 7.66 13.96 7.33 13.91 7H16V5ZM12 9V12C12 12.22 11.97 12.47 11.93 12.7L11.83 13.35L11.46 14C10.74 15.24 9.42 16 8 16C6.58 16 5.26 15.23 4.54 14L4.17 13.36L4.07 12.71C4.0269 12.4757 4.00349 12.2382 4 12V8C4 7.77 4.03 7.52 4.07 7.3L4.17 6.65L4.54 6C4.84 5.48 5.26 5.03 5.75 4.69L6.32 4.3L7.06 4.12C7.67988 3.96026 8.33012 3.96026 8.95 4.12L9.63 4.28L10.24 4.7C10.74 5.04 11.15 5.48 11.45 6.01L11.83 6.66L11.93 7.31C11.97 7.53 12 7.78 12 8V9ZM6 11H10V13H6V11ZM6 7H10V9H6V7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBug);
export default __webpack_public_path__ + "static/media/bug.c2822d14.svg";
export { ForwardRef as ReactComponent };